import { useState, useEffect, useRef } from 'react';
import { ReactComponent as CameraIcon } from 'assets/icons/camera.svg';
import styles from './UploadImage.module.scss';
import profilePic from '../../../../assets/images/profilePic2.png';

type Props = {
    src: string;
    getImageFile?: (file: File) => void;
};

const UploadImage = ({ src, getImageFile }: Props) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [image, setImage] = useState<string | ArrayBuffer | null>(null);
    const imgPickerRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        setImage(src);
    }, [src]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file: File | null = event.target.files ? event.target.files[0] : null;
        setSelectedFile(file);

        if (getImageFile && file) {
            getImageFile(file);
        }

        const fileData: FileReader = new FileReader();
        fileData.onloadend = handleFile;

        if (file) {
            fileData.readAsDataURL(file);
        }
    };

    const pickFile = () => {
        if (imgPickerRef) {
            imgPickerRef.current?.click();
        }
    };

    const handleFile = (ev: ProgressEvent<FileReader>) => {
        if (ev?.target) {
            const content: string | ArrayBuffer | null = ev.target.result;
            setImage(content);
        }
    };

    return (
        <div className={styles.root}>
            <div className={styles['img-wrapper']}>
                <input
                    className={styles.fileInput}
                    ref={imgPickerRef}
                    type="file"
                    accept="image/*, .png, .jpg, .gif, .web,"
                    onChange={handleChange}
                />
                {!selectedFile && !src && <img src={profilePic} alt="Placeholder" />}
                {(selectedFile || src) && <img src={image as string} alt="My Account" />}
            </div>
            <button className={styles['pick-img-btn']} onClick={pickFile}>
                <CameraIcon />
            </button>
        </div>
    );
};

export default UploadImage;
